"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge } from "@matsuricon/ui/badge";
import { Input } from "@matsuricon/ui/input";
import { Label } from "@matsuricon/ui/label";
import { type ReactNode, useMemo, useRef, useState } from "react";
import type { LibraryEntry } from "./inventory";
import { matchesLibraryQuery, normalizeLibrarySearch } from "./search";
export type LibraryCatalogLabels = {
  search: string;
  placeholder: string;
  summary: string;
  entrySingular: string;
  entryPlural: string;
  physicalItems: string;
  alphabet: string;
  noResults: string;
};
export function LibraryCatalog(t0) {
  const $ = _c(72);
  const {
    entries,
    totalItems,
    idPrefix,
    labels,
    icon
  } = t0;
  let t1;
  if ($[0] !== idPrefix) {
    t1 = group => `${idPrefix}-${group === "#" ? "numbers" : group.toLowerCase()}`;
    $[0] = idPrefix;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupId = t1;
  const [query, setQuery] = useState("");
  const detailsRef = useRef(null);
  let t2;
  if ($[2] !== entries) {
    t2 = entries.map(_temp);
    $[2] = entries;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchIndex = t2;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== entries || $[5] !== groupId || $[6] !== icon || $[7] !== idPrefix || $[8] !== labels.alphabet || $[9] !== labels.entryPlural || $[10] !== labels.entrySingular || $[11] !== labels.noResults || $[12] !== labels.physicalItems || $[13] !== labels.placeholder || $[14] !== labels.search || $[15] !== labels.summary || $[16] !== query || $[17] !== searchIndex || $[18] !== totalItems) {
    const queryWords = normalizeLibrarySearch(query).split(" ").filter(Boolean);
    const filteredEntries = queryWords.length ? searchIndex.filter(entry_0 => matchesLibraryQuery(entry_0, queryWords)).map(_temp2) : entries;
    const libraryGroups = [...filteredEntries.reduce(_temp3, new Map())].sort(_temp4);
    t11 = "flex flex-col gap-4";
    const t13 = `${idPrefix}-search`;
    let t14;
    if ($[29] !== labels.search || $[30] !== t13) {
      t14 = <Label htmlFor={t13}>{labels.search}</Label>;
      $[29] = labels.search;
      $[30] = t13;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    const t15 = `${idPrefix}-search`;
    const t16 = `${idPrefix}-results`;
    let t17;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = event => {
        setQuery(event.target.value);
        if (detailsRef.current) {
          detailsRef.current.open = true;
        }
      };
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    let t18;
    if ($[33] !== labels.placeholder || $[34] !== query || $[35] !== t15 || $[36] !== t16) {
      t18 = <Input id={t15} type="search" placeholder={labels.placeholder} value={query} aria-controls={t16} onChange={t17} />;
      $[33] = labels.placeholder;
      $[34] = query;
      $[35] = t15;
      $[36] = t16;
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    const t19 = queryWords.length ? `${filteredEntries.length} matching ${filteredEntries.length === 1 ? labels.entrySingular : labels.entryPlural}` : `${entries.length} ${labels.entryPlural}`;
    let t20;
    if ($[38] !== t19) {
      t20 = <p role="status" aria-live="polite" aria-atomic="true" className="text-sm text-muted-foreground">{t19}</p>;
      $[38] = t19;
      $[39] = t20;
    } else {
      t20 = $[39];
    }
    if ($[40] !== t14 || $[41] !== t18 || $[42] !== t20) {
      t12 = <div className="flex flex-col gap-2">{t14}{t18}{t20}</div>;
      $[40] = t14;
      $[41] = t18;
      $[42] = t20;
      $[43] = t12;
    } else {
      t12 = $[43];
    }
    t6 = detailsRef;
    t7 = true;
    t8 = idPrefix;
    t9 = "group/library rounded-2xl border border-border bg-background/55 open:border-primary/25";
    let t21;
    if ($[44] !== icon) {
      t21 = <span className="grid size-11 shrink-0 place-items-center border border-primary/25 bg-primary/10 text-primary rounded-full">{icon}</span>;
      $[44] = icon;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    let t22;
    if ($[46] !== labels.summary) {
      t22 = <span className="block font-sans text-lg font-bold sm:text-xl">{labels.summary}</span>;
      $[46] = labels.summary;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    const t23 = `${entries.length} ${labels.entryPlural} · ${totalItems} ${labels.physicalItems}`;
    let t24;
    if ($[48] !== t23) {
      t24 = <span className="mt-1 block text-sm text-muted-foreground">{t23}</span>;
      $[48] = t23;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== t22 || $[51] !== t24) {
      t25 = <span className="min-w-0 flex-1">{t22}{t24}</span>;
      $[50] = t22;
      $[51] = t24;
      $[52] = t25;
    } else {
      t25 = $[52];
    }
    let t26;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <HugeiconsIcon aria-hidden="true" className="shrink-0 text-muted-foreground transition-transform duration-200 group-open/library:rotate-180" icon={ArrowDown01Icon} strokeWidth={2} />;
      $[53] = t26;
    } else {
      t26 = $[53];
    }
    if ($[54] !== t21 || $[55] !== t25) {
      t10 = <summary className="flex min-h-16 cursor-pointer list-none items-center gap-4 px-4 py-4 font-sans outline-none transition-colors hover:bg-primary/5 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset [&::-webkit-details-marker]:hidden sm:px-6">{t21}{t25}{t26}</summary>;
      $[54] = t21;
      $[55] = t25;
      $[56] = t10;
    } else {
      t10 = $[56];
    }
    t3 = `${idPrefix}-results`;
    t4 = "border-t border-border/70 px-4 py-6 sm:px-6 sm:py-8";
    t5 = filteredEntries.length ? <><nav aria-label={labels.alphabet} className="mb-8 overflow-x-auto border-b border-border/70 pb-4"><ul className="flex min-w-max flex-wrap gap-2">{libraryGroups.map(t27 => {
            const [group_1] = t27;
            return <li key={group_1}><a href={`#${groupId(group_1)}`} className="inline-flex min-h-11 min-w-11 items-center justify-center border border-border bg-card px-3 font-sans text-xs font-semibold text-foreground transition-colors hover:border-primary/25 hover:bg-primary/10 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl">{group_1}</a></li>;
          })}</ul></nav><div className="grid items-start gap-8 md:grid-cols-2 xl:grid-cols-3">{libraryGroups.map(t28 => {
          const [group_2, entries_1] = t28;
          return <section key={group_2} id={groupId(group_2)} aria-labelledby={`${groupId(group_2)}-title`} className="scroll-mt-36"><h3 id={`${groupId(group_2)}-title`} className="border-b border-primary/25 pb-2 font-display text-2xl font-bold text-primary">{group_2}</h3><ul className="divide-y divide-border/60 font-sans">{entries_1.map(_temp5)}</ul></section>;
        })}</div></> : <p className="text-muted-foreground">{labels.noResults}</p>;
    $[4] = entries;
    $[5] = groupId;
    $[6] = icon;
    $[7] = idPrefix;
    $[8] = labels.alphabet;
    $[9] = labels.entryPlural;
    $[10] = labels.entrySingular;
    $[11] = labels.noResults;
    $[12] = labels.physicalItems;
    $[13] = labels.placeholder;
    $[14] = labels.search;
    $[15] = labels.summary;
    $[16] = query;
    $[17] = searchIndex;
    $[18] = totalItems;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t3 = $[22];
    t4 = $[23];
    t5 = $[24];
    t6 = $[25];
    t7 = $[26];
    t8 = $[27];
    t9 = $[28];
  }
  let t13;
  if ($[57] !== t3 || $[58] !== t4 || $[59] !== t5) {
    t13 = <div id={t3} className={t4}>{t5}</div>;
    $[57] = t3;
    $[58] = t4;
    $[59] = t5;
    $[60] = t13;
  } else {
    t13 = $[60];
  }
  let t14;
  if ($[61] !== t10 || $[62] !== t13 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t14 = <details ref={t6} suppressHydrationWarning={t7} data-library-catalog={t8} className={t9}>{t10}{t13}</details>;
    $[61] = t10;
    $[62] = t13;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t14;
  } else {
    t14 = $[67];
  }
  let t15;
  if ($[68] !== t11 || $[69] !== t12 || $[70] !== t14) {
    t15 = <div className={t11}>{t12}{t14}</div>;
    $[68] = t11;
    $[69] = t12;
    $[70] = t14;
    $[71] = t15;
  } else {
    t15 = $[71];
  }
  return t15;
}
function _temp5(entry_3) {
  return <li key={entry_3.name} data-library-entry={entry_3.name} className="flex min-h-11 items-center justify-between gap-3 py-2.5 text-sm leading-snug"><span className="text-foreground">{entry_3.name}</span>{entry_3.copies > 1 || entry_3.ageRestricted ? <span className="flex shrink-0 flex-wrap justify-end gap-1.5">{entry_3.copies > 1 ? <Badge variant="outline">{`${entry_3.copies} copies`}</Badge> : null}{entry_3.ageRestricted ? <Badge variant="secondary">18+</Badge> : null}</span> : null}</li>;
}
function _temp4(t0, t1) {
  const [first] = t0;
  const [second] = t1;
  return first.localeCompare(second, "en", {
    numeric: true
  });
}
function _temp3(groups, entry_2) {
  const firstCharacter = entry_2.name.charAt(0).toUpperCase();
  const group_0 = firstCharacter >= "A" && firstCharacter <= "Z" ? firstCharacter : "#";
  const entries_0 = groups.get(group_0) ?? [];
  entries_0.push(entry_2);
  groups.set(group_0, entries_0);
  return groups;
}
function _temp2(entry_1) {
  return entry_1.entry;
}
function _temp(entry) {
  const title = normalizeLibrarySearch(entry.name);
  return {
    entry,
    title,
    words: title.split(" ")
  };
}